import { Tooltip } from "@fluentui/react-components";
import { IItemBarProps } from "./Models";
import {
  ActiveBarWrapper,
  ActiveLineWrapper,
  BoxItemBarWrapper,
  ImgIconTooltipWrapper,
  ItemBarTitleWrapper,
  ItemBarTooltipWrapper,
  ItemBarWrapper,
} from "./Styles";
import { BuildRCAttribute } from "@/common/function/RCAttribute";

const ItemBar = ({
  id,
  title,
  icon,
  activeIcon,
  path,
  onSelect,
  isTooltip,
  theme,
                     currentTab
}: IItemBarProps) => {
  const onSelectItem = (): void => {
    if (onSelect) {
      onSelect(id, path);
    }
  };

  const isActive = currentTab === id;

  const onRenderMenu = (): JSX.Element => {
    if (isTooltip) {
      return (
        <ItemBarTooltipWrapper className="ItemBarTooltipWrapper">
          <ActiveBarWrapper
            className="ActiveBarWrapper"
            $isActive={isActive}
            $theme={theme}
          ></ActiveBarWrapper>
           <Tooltip  content={title} relationship="label">
            <ImgIconTooltipWrapper
              className="ImgIconTooltipWrapper"
              $isActive={isActive}
              {...BuildRCAttribute(`menu_bar_item.${id}.${isActive}`)}
            >
              {!(isActive) ? icon : activeIcon}
            </ImgIconTooltipWrapper>
          </Tooltip>
        </ItemBarTooltipWrapper>
      );
    }
    return (
      <ItemBarWrapper className="ItemBarWrapper">
        <ActiveLineWrapper
          className="ActiveLineWrapper"
          $isActive={isActive}
        ></ActiveLineWrapper>
        <ImgIconTooltipWrapper className="ImgIconTooltipWrapper" {...BuildRCAttribute(`menu_bar_item.${id}.${isActive}`)}>
          {!(isActive) ? icon : activeIcon}
        </ImgIconTooltipWrapper>
        <div>
          <ItemBarTitleWrapper
            className="ItemBarTitleWrapper"
            $isActive={isActive}
          >
            {title}
          </ItemBarTitleWrapper>
        </div>
      </ItemBarWrapper>
    );
  };

  return (
    <BoxItemBarWrapper className="BoxItemBarWrapper" onClick={onSelectItem}>
      {onRenderMenu()}
    </BoxItemBarWrapper>
  );
};

export default ItemBar;
